import { Scene } from '@bighealth/types';

import { isDevMode } from 'lib/isDevMode';

/**
 * Debug data
 */
const getSceneToThrowInModal = (): Scene => ({
  component: 'Scene',
  childNodes: [
    {
      component: 'Modal',
      childNodes: isDevMode()
        ? [
            {
              component: 'DebugThrow',
            },
          ]
        : [],
    },
  ],
});

export { getSceneToThrowInModal };
